let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1U88s")).then(() => parcelRequire('hKgJo'));